import { render, staticRenderFns } from "./RoomCrad.vue?vue&type=template&id=2a556166&"
import script from "./RoomCrad.vue?vue&type=script&lang=js&"
export * from "./RoomCrad.vue?vue&type=script&lang=js&"
import style0 from "./RoomCrad.vue?vue&type=style&index=0&id=2a556166&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports